/**
 * Previous Step Detection Utilities
 * Pure functions for detecting if a step is being edited vs first visit
 */

import type { CopilotState } from '../data-layer/types';

/**
 * Check if user is editing a previously completed or skipped step
 */
const isEditingPreviousStep = (
  stepName: string,
  getState: () => unknown
): boolean => {
  const state = getState() as { copilot?: CopilotState };
  const { completedSteps = [], skippedSteps = [] } =
    state.copilot?.navigation ?? {};

  return completedSteps.includes(stepName) || skippedSteps.includes(stepName);
};

export default isEditingPreviousStep;
